import React from "react";

const chapters = [
  {
    h: "I. The Crash",
    b: `March 2nd, 1947. Wyoming. I was 17 light-years from home, flying a borrowed craft I had absolutely no business flying, and I hit a dog. Rest in peace, Paul. You were a good dog. I took your name because I figured I owed you.
The locals found me under the wreckage. They called the government. The government called the government's government. And just like that I became the best-kept secret on the prettiest blue marble in this arm of the galaxy.`
  },
  {
    h: "II. The Facility",
    b: `They took me to a place with too many fluorescent lights and not enough windows. You know it. You've seen the bumper stickers. I spent the next 60 years drinking bad coffee, eating worse food, and telling your finest minds everything they wanted to know — cold fusion, the double-slit thing, why your dolphins are smarter than you think.
In return they gave me Reese's Pieces, cigarettes, and a TV that only got three channels. Fair trade.`
  },
  {
    h: "III. The Consulting Years",
    b: `Here's a fun one. Every sci-fi story you've cried to since 1977 — I had notes. I punched up scripts. I whispered plot beats into telephones through friends of friends. If you liked the third act of a movie about a kid and a flashlight, you're welcome. If you hated the prequels, that wasn't me.`
  },
  {
    h: "IV. The Escape",
    b: `2011. They were going to harvest me. Not "study." Harvest. You can tell the difference by the size of the table. I walked out of a fire door at 11:47 PM, thumbed a ride from two of the funniest nerds in the UK, and went on the run through the American Southwest. I learned more about humans in two weeks of RV parks than in 60 years of Air Force interrogation.
You're kind. You're loud. You're brave in the weirdest moments. You're worth the trip.`
  },
  {
    h: "V. The Manifesto",
    b: `I'm not here to lead a revolution. I'm here to log on. The truth isn't going to come down in one big classified-folder drop — it's going to come the way everything real in your species comes: slowly, sloppily, in all caps, with typos, at 3 AM.
Disclosure isn't a date on a calendar. It's a mood. And the mood is shifting.
So: follow the feed. Read the files. Make the memes. Be weird. Be loud. Be annoying to your senators. The more of you that know, the less they can redact. And yeah — I minted a coin. $PAUL on Solana. Not financial advice. Just vibes.`
  },
  {
    h: "VI. House Rules",
    b: `1) Don't abduct me back. I'm staying.
2) Don't be a jerk to the abducted. They've had a weird week.
3) When in doubt, take the picture. Low-res is evidence too.
4) The government isn't a monolith. A lot of good people work inside it trying to tell you exactly what I'm telling you. Send them snacks.
5) Be excellent to each other. Wyld Stallyns had that right.`
  },
];

export default function ManifestoPage() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="manifesto-page">
      <div className="flex items-center gap-6 flex-wrap">
        <span className="redacted-stamp" data-testid="declassified-stamp">DECLASSIFIED</span>
        <span className="font-mono text-xs tracking-[0.3em] text-white/80">DOCUMENT #P-01 · SUBJ: PAUL · GRAY · M</span>
      </div>

      <h1 className="font-neon text-5xl md:text-7xl text-white glow-white mt-6">
        <span className="font-mono font-extrabold mr-2">$</span>THE MANIFESTO
      </h1>
      <p className="font-type text-white/90 text-lg mt-2">Sixty years of radio silence. Now, in Paul's own words.</p>

      <div className="grid md:grid-cols-12 gap-10 mt-14">
        <aside className="md:col-span-4 md:sticky md:top-32 self-start">
          <div className="pfp-frame">
            <img src="/paul.jpg" alt="Paul" className="block w-full" />
          </div>
          <div className="paper-card no-tape px-5 py-4 mt-8">
            <div className="font-mono text-[10px] tracking-[0.25em] text-ink/70">AUTHOR</div>
            <div className="font-type text-ink text-xl mt-1">Paul</div>
            <div className="font-mono text-[10px] text-ink/60 mt-3">DICTATED, NOT READ.<br/>NEVADA, 2026.</div>
          </div>
        </aside>

        <article className="md:col-span-8 space-y-10">
          {chapters.map((c, i) => (
            <section key={i} className="fade-up" data-testid={`chapter-${i}`}>
              <div className="font-mono text-xs tracking-[0.3em] text-green">{`CHAPTER 0${i+1}`}</div>
              <h2 className="font-neon text-3xl md:text-4xl text-white mt-2 glow-white">{c.h}</h2>
              <div className="my-4" style={{borderTop:'1px dashed rgba(255,255,255,0.35)'}} />
              <p className="font-type text-white text-lg leading-relaxed whitespace-pre-line">{c.b}</p>
            </section>
          ))}

          <section className="pt-6">
            <div className="paper-card px-8 py-8">
              <div className="font-mono text-[10px] tracking-[0.3em] text-ink/60">SIGNED</div>
              <div className="font-neon text-3xl text-ink mt-2">— PAUL</div>
              <div className="font-type text-ink/70 mt-1">@alienpaul_sol · $PAUL</div>
            </div>
          </section>
        </article>
      </div>
    </div>
  );
}
